export default "__VITE_ASSET__J8_uqUAy__"